<template>
  <fieldset class="facette-group card open" :id="categorieId">
    <legend class="title-level level-3" :id="`facet-group-${categorieId}`">
      <button
        class="btn btn-collapse btn-block d-flex justify-content-between"
        type="button"
        :aria-expanded="opened"
        :aria-controls="`facet-${categorieId}`"
        @click="toggleDisplay"
      >
        {{ categorieName }}
        <i class="fa" :class="{ 'fa-chevron-down': opened, 'fa-chevron-left': !opened }" aria-hidden="true"></i>
      </button>
    </legend>
    <div
      v-show="opened"
      class="card-body show"
      :id="`facette-${categorieId}`"
      :aria-labelledby="`facet-group-${categorieId}`"
      :aria-hidden="opened"
    >
      <div class="input-group input-group-sm mb-2">
        <div class="input-group-prepend">
          <span class="fa fa-search input-group-text"></span>
        </div>
        <label for="searchfacette" class="sr-only">{{ placeHolderString }}</label>
        <input
          type="text"
          class="form-control flex-grow-1"
          id="searchfacette"
          :placeholder="placeHolderString"
          v-model="filter"
        />
        <button
          v-if="filter.length > 0"
          type="button"
          class="clear"
          data-dismiss="modal"
          :aria-label="i18n.abortSearch"
          @click="resetFilter"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <p class="sr-only">{{ count }} {{ i18n.results }}</p>
      <ul class="list-facette pt-2 pb-2" aria-live="polite">
        <facet v-for="facet in filteredFacets" :key="facet.key" :facet="facet"></facet>
      </ul>
    </div>
  </fieldset>
</template>

<script>
import Facet from './Facet';

export default {
  components: {
    Facet,
  },
  props: {
    categorieId: {
      type: String,
      required: true,
    },
    opened: {
      type: Boolean,
    },
  },
  data: function() {
    return {
      // Calculate translations to simplify HTML binding
      i18n: {
        results: this.$t(`results`),
        abortSearch: this.$t(`abortSearch`),
        activites: {
          placeholder: this.$t(`activites.placeholder`),
        },
      },
      filter: '',
    };
  },
  computed: {
    facets() {
      return this.$store.getters.getFacetsByCategorie(this.categorieId);
    },
    count() {
      return this.filteredFacets.length;
    },
    filteredFacets() {
      // case insensitive filter
      return this.facets.filter((facet) => {
        return this.filter !== '' ? this.includesStringInsensitive(facet.key, this.filter) : true;
      });
    },
    categorieName() {
      return this.$t(`statics.${this.categorieId}.label`);
    },
    placeHolderString() {
      return this.$t(`statics.${this.categorieId}.placeholder`);
    },
  },
  methods: {
    /**
     * Emit event to notify categorie toggle
     */
    toggleDisplay() {
      this.$emit('toggle-clicked');
    },
    includesStringInsensitive(str1, str2) {
      const str1NoAccent = str1.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      const str2NoAccent = str2.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      return str1NoAccent.toLowerCase().includes(str2NoAccent.toLowerCase());
    },
    resetFilter() {
      this.filter = '';
    },
  },
};
</script>

<style lang="less">
@import 'categorie.less';
</style>
